import React from 'react'
import theme from '../config/theme'

interface ToggleProps {
  checked: boolean
  onChange: (checked: boolean) => void
  disabled?: boolean
  className?: string
  label?: string
  colorChecked?: string
}

const Toggle: React.FC<ToggleProps> = ({
  checked,
  onChange,
  disabled = false,
  className = '',
  label,
  colorChecked = theme.brandColor.red
}) => {
  return (
    <div className={`flex items-center space-x-3 ${className}`}>
      {label && (
        <span 
          className="text-sm font-medium"
          style={{ color: theme.color.gray500 }}
        >
          {label}
        </span>
      )}
      <button
        type="button"
        onClick={() => !disabled && onChange(!checked)}
        disabled={disabled}
        className={`relative inline-flex h-6 w-11 items-center rounded-full transition-colors focus:outline-none focus:ring-2 focus:ring-offset-2 ${
          disabled ? 'cursor-not-allowed opacity-50' : 'cursor-pointer'
        }`}
        style={{
          backgroundColor: checked ? colorChecked : theme.color.light300
        }}
      >
        <span
          className={`inline-block h-4 w-4 transform rounded-full transition-transform ${
            checked ? 'translate-x-6' : 'translate-x-1'
          }`}
          style={{ backgroundColor: theme.color.light100 }}
        />
      </button>
    </div>
  )
}

export default Toggle
